import React, { useState } from 'react';

// Keep the entire product visible; extend its tones behind it to fill every card.
export default function DoorImage({ src, alt = '', fallback, className = '' }) {
 const [failed, setFailed] = useState(false);
 const image = failed && fallback ? fallback : src;
 return <div className={'door-photo ' + className}>
   <img src={image} alt="" aria-hidden="true" className="door-photo-backdrop" />
   <img src={image} alt={alt} className="door-photo-product" onError={() => setFailed(true)} loading="lazy" decoding="async" />
 </div>;
}
